// extracted by mini-css-extract-plugin
export default {"wrap":"ViewStudents_wrap__Ot4fo","selectionBar":"ViewStudents_selectionBar__aqXSu","content":"ViewStudents_content__EGJJi","open":"ViewStudents_open__LFEBU"};